import { useRef, type MutableRefObject } from "react";

import type { BookTimelineLayout } from "@/lib/timeline/book/BookLayout";

/** A journey switch moves the playhead, so a locked camera must go and find it. */
export function useRestoredHold(
  holdUntilPlayback: boolean,
  layout: BookTimelineLayout,
): MutableRefObject<boolean> {
  const hold = useRef(holdUntilPlayback);
  const seenLayout = useRef(layout);
  if (seenLayout.current !== layout) {
    seenLayout.current = layout;
    hold.current = false;
  }
  return hold;
}
